/* eslint-disable @angular-eslint/use-lifecycle-interface */
import {
    ApplicationRef,
    NgModule,
    ErrorHandler,
    APP_INITIALIZER,
} from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { ToastrModule } from 'ngx-toastr';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
// import * as Sentry from  '@sentry/angular-ivy';

import { UnauthenServiceModule } from './core/services/unauthen-service.module';
import { AuthenServiceModule } from './core/services/authen-service.module';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { LoadingComponent } from './modules/components/loading/loading.component';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

const playerFactory = (): any => player;
@NgModule({
    // providers: [{
    //     provide: ErrorHandler,
    //     useValue: Sentry.createErrorHandler({
    //         showDialog: true,
    //     }),
    // }, {
    //     provide: Sentry.TraceService,
    //     deps: [Router],
    // },
    //     {
    //         provide: APP_INITIALIZER,
    //         // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    //         useFactory: () => () => {},
    //         deps: [Sentry.TraceService],
    //         multi: true,
    //     },
    // ],
    declarations: [AppComponent, LoadingComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        ToastrModule.forRoot(),
        LottieModule.forRoot({ player: playerFactory }),
        UnauthenServiceModule,
        AuthenServiceModule,
        FuseLoadingBarModule,
    ],
    entryComponents: [LoadingComponent]
})
export class AppModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(LoadingComponent, { injector });
        customElements.define('news-widget', el);
    }

    ngDoBootstrap(appRef: ApplicationRef): void {
        if (document.querySelector('app-root')) {
            appRef.bootstrap(AppComponent);
        }
    }
}
